/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions, FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions';
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseStatistics.js.map